import * as l from '../lib/littlejs.esm.js';
import Globals from './globals.ts';
const HUD_PADDING = 32;
const HUD_FONTSIZE = 32;
// Colors
const REX_COLOR = l.hsl(.1, 1, .5);
const CHIP_COLOR = l.hsl(.6, 1, .5);
const BATTERY_COLOR = l.hsl(.5, 1, .5);
const HEALTH_COLOR = l.hsl(0, 1, .5);
const LINE_COLOR = l.hsl(0, 0, 0, 0);
export default class HUD {
    formatTime(milliseconds) {
        const totalSeconds = Math.floor(milliseconds / 1000);
        const minutes = Math.floor(totalSeconds / 60);
        const seconds = totalSeconds % 60;
        const ms = Math.floor((milliseconds % 1000) / 10); // Two-digit milliseconds
        return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}:${ms.toString().padStart(2, '0')}`;
    }
    render(currentPlayer, rexHealth, chipBattery, pickupText) {
        // Starting positions for the texts
        const text_x_left = HUD_PADDING;
        const text_x_right = l.mainCanvasSize.x - HUD_PADDING;
        const text_y = HUD_PADDING + HUD_FONTSIZE / 2;
        const canvWidth = l.mainCanvasSize.x;
        const canvHeight = l.mainCanvasSize.y;
        // Display current player
        const playerText = `Player: ${currentPlayer.toUpperCase()}`;
        l.drawTextScreen(playerText, l.vec2(HUD_PADDING, HUD_PADDING + HUD_FONTSIZE / 2), HUD_FONTSIZE, currentPlayer == 'rex' ? REX_COLOR : CHIP_COLOR, 1, LINE_COLOR, 'left');
        // Round the battery to superior digit
        chipBattery = Math.ceil(chipBattery);
        // Display health for Rex / battery for Chip
        const healthText = currentPlayer == 'chip' ? `Battery: ${chipBattery}%` : `Health: ${rexHealth}`;
        const healthColor = currentPlayer == 'chip' ? BATTERY_COLOR : HEALTH_COLOR;
        l.drawTextScreen(healthText, l.vec2(canvWidth - HUD_PADDING, HUD_PADDING + HUD_FONTSIZE / 2), HUD_FONTSIZE, healthColor, 1, LINE_COLOR, 'right');
        // Draw battery bar for Chip
        if (currentPlayer == 'chip') {
            const barWidth = 200;
            const barHeight = 20;
            const barPos = l.vec2(canvWidth - HUD_PADDING - 100, HUD_PADDING + (3 * HUD_FONTSIZE) / 2);
            // Background
            l.drawRect(barPos, l.vec2(barWidth, barHeight), l.hsl(0, 0, 1), 0, true, true);
            // Fill
            let fillWidth = (chipBattery / 100) * barWidth;
            fillWidth = fillWidth <= 0 ? 0 : fillWidth;
            // Horizontal offset so the fill is centered to the left
            const offsetX = -(barWidth - fillWidth) / 2;
            let fillPos = barPos.copy();
            fillPos.x += offsetX;
            l.drawRect(fillPos, l.vec2(fillWidth, barHeight), healthColor, 0, true, true);
        }
        // Display keys count or Rex key status
        let keysText = '';
        if (Globals.rexHasKey) {
            keysText = `Key (Rex)`;
        }
        else if (Globals.keys > 0) {
            keysText = `Keys: ${Globals.keys} (Chip)`;
        }
        else {
            keysText = `Keys: ${Globals.keys}`;
        }
        l.drawTextScreen(keysText, l.vec2(canvWidth / 2, HUD_PADDING + HUD_FONTSIZE / 2), HUD_FONTSIZE, l.YELLOW, 1, LINE_COLOR, 'center');
        // Display timer
        let timerText = '';
        if (Globals.levelCompleted) {
            timerText = `Time: ${this.formatTime(Globals.levelCompletionTime)}`;
        }
        else {
            const currentTime = Date.now() - Globals.levelStartTime;
            timerText = `Time: ${this.formatTime(currentTime)}`;
        }
        l.drawTextScreen(timerText, l.vec2(canvWidth / 2, HUD_PADDING + HUD_FONTSIZE * 1.5), HUD_FONTSIZE, l.WHITE, 1, LINE_COLOR, 'center');
        // Display pickup text if provided
        if (pickupText) {
            l.drawTextScreen(pickupText, l.vec2(canvWidth / 2, canvHeight - HUD_PADDING), HUD_FONTSIZE, l.WHITE, 1, LINE_COLOR, 'center');
        }
    }
}
